export const decemberUppercase = "lqa";
export default {decemberUppercase};